export default {"src":"/_next/static/image/components/ui/Icon/icons/clock.73a5bb4728a8abe03e3cf2711564a11c.svg","height":24,"width":24};